























import { Vue, Component } from "vue-property-decorator";
@Component
export default class URecaptchaStatement extends Vue {
  public created() {
    /** This init call is not strictly necessary – but it will speed things up
     * for the very first time the Google recaptcha library is requested. */
    this.$store.dispatch("utils/recaptcha/init").catch(err => err);
  }
}
